import React, { Fragment, useState } from 'react';
import { ModalHeader, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import { StyledModal, StyledModalBody } from './styled';
import '../../styles/app.css'

export const InfoIcon = ({ className, iconName, modalContent }) => {
  const [ showModal, setShowModal ] = useState(false);
  
  return (
    <Fragment>
      <FontAwesomeIcon className={className} icon={iconName} onClick={() => setShowModal(true)} />
      <StyledModal size="md" centered isOpen={showModal}>
        <ModalHeader toggle={() => setShowModal(false)}>Foreign Manufacturer Engineering Assist</ModalHeader>
        <StyledModalBody>{modalContent}</StyledModalBody>
        <ModalFooter>
          <Button className="primary-antd-button" primary onClick={() => setShowModal(false)}>Dismiss</Button>
        </ModalFooter>
      </StyledModal>
    </Fragment>
  );
}